<template>
  <v-container fluid>
    <nauja-paslauga class="pa-0" />
    <aktyvios-paslaugos class="pa-0 mt-5 mb-5" />
  </v-container>
</template>

<script>
import NaujaPaslauga from './NaujaPaslauga'
import AktyviosPaslaugos from './AktyviosPaslaugos'
// import { mapGetters } from 'vuex'

export default {
  name: 'SavitarnaDashboard',
  components: {
    NaujaPaslauga,
    AktyviosPaslaugos,
  },
  data() {
    return {
      //
    }
  },
  computed: {
    // ...mapGetters(['userRole']),
    //
  },
  created() {
    //
  },
  methods: {
    //
  },
}
</script>
